export const FETCH_QUALIFICATIONS_REQUEST = 'FETCH_QUALIFICATIONS_REQUEST';
export const FETCH_QUALIFICATIONS_SUCCESS = 'FETCH_QUALIFICATIONS_SUCCESS';
export const FETCH_QUALIFICATIONS_FAILED = 'FETCH_QUALIFICATIONS_FAILED';

export const FETCH_QUALIFICATION_BY_ID_REQUEST = 'FETCH_QUALIFICATION_BY_ID_REQUEST';
export const FETCH_QUALIFICATION_BY_ID_SUCCESS = 'FETCH_QUALIFICATION_BY_ID_SUCCESS';
export const FETCH_QUALIFICATION_BY_ID_FAILED = 'FETCH_QUALIFICATION_BY_ID_FAILED';

export const FETCH_UPDATE_QUALIFICATION_REQUEST = 'FETCH_UPDATE_QUALIFICATION_REQUEST';
export const FETCH_UPDATE_QUALIFICATION_SUCCESS = 'FETCH_UPDATE_QUALIFICATION_SUCCESS';
export const FETCH_UPDATE_QUALIFICATION_FAILED = 'FETCH_UPDATE_QUALIFICATION_FAILED';
